<template>
  <div class="csrf-input">
    <input
      type="hidden"
      :name="name"
      :value="value"
    >
  </div>
</template>

<script>
  const CsrfInput = {
    name: 'csrf-input',
    data() {
      return {
        name: window.__globalConfig.csrfToken.name,
        value: window.__globalConfig.csrfToken.value
      };
    },
    methods: {
      getName() {
        return this.name;
      },
      getValue() {
        return this.value;
      }
    }
  };

  export default CsrfInput;
</script>
